namespace GeniuzPOS.InventoryReport {
    export interface IcReport08Row {
        Id?: string;
        SkuCode?: string;
        SkuDesc?: string;
        SkuEnDesc?: string;
        QtyOnhand?: number;
        Countt?: number;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        ConsignFg?: number;
        DtList?: IcReport08DtRow[];
    }

    export namespace IcReport08Row {
        export const idProperty = 'SkuCode';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport08';
        export const deletePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const insertPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const readPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const updatePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            SkuEnDesc = "SkuEnDesc",
            QtyOnhand = "QtyOnhand",
            Countt = "Countt",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            ConsignFg = "ConsignFg",
            DtList = "DtList"
        }
    }
}
